import React, { Component } from "react"
import { validateToken } from '../../helpers/jwt-token-access/accessToken'
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { Card, CardBody, Col, Container, Row, TabPane, Nav, NavItem, NavLink, TabContent, Spinner } from "reactstrap"

import { Link } from "react-router-dom"
import { BaseUrl } from "../../helpers/Baseurl"
import classnames from "classnames";
import './customStyle.css'

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

class ItinerariesPayments extends Component {
    constructor(props) {
        super(props)
        this.obj = JSON.parse(localStorage.getItem("authUser"))
        if (!this.obj) {
            this.props.history.push('/logout')
        } else if (!validateToken(this.obj.access)) {
            this.props.history.push('/logout')
        }
        this.state = {
            itinerary_id: "",
            alert_confirm: false,
            success_confirm: false,
            dynamic_title: "",
            dynamic_description: "",

            bookingDate: null,
            selectedStartDate: null,
            selectedendDate: null,

            itineraries: [],
            page: 1,
            totalSize: 0,
            loadUpcomming: false,
            sizePerPage: 20,

            pendingPayments: [],
            pendingPage: 1,
            pendingtotalSize: 0,
            loadPending: false,

            completedPayments: [],
            completedPage: 1,
            completedtotalSize: 0,
            loadCompleted: false,

            searchText: "",
            selectedFilterOptions: { label: "Filter By ", value: null },
            selectedPackegeType: { label: "Budget", value: "Budget" },
            selectedStatus: { label: "Processing", value: "processing" },
            selectedUser: { label: "Select User", value: null },
            filter_option: "",
            UsersGroup: [],
            activeTab: "upcomming",
            today: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,



            breadcrumbItems: [
                { title: "Planmans", link: "/dashboard" },
                { title: "Payments", link: "#" },
            ],
        }

        toastr.options = {
            positionClass: "toast-top-right",
            closeButton: "true",
            progressBar: "true",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut",
            showDuration: 300,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000
        }

        this.handleItineraryClicks = this.handleItineraryClicks.bind(this)
        this.handleFilterSubmit = this.handleFilterSubmit.bind(this)
        this.clearFilter = this.clearFilter.bind(this)
        this.toggledescription = this.toggledescription.bind(this);
    }
    componentDidCatch(error) {
        // Changing the state to true
        // if some error occurs
        console.log(error)
        // this.props.history.push('/dashboard')
        toastr.error("Something Went Wrong", "")
    }

    async componentDidMount() {
      document.title = "Itineraries | Planmans";
      const url = `${BaseUrl}/api/itineraries/itinerary-payment/?size=${this.state.sizePerPage}&page=1&gt_due_date=${this.state.today}&status=pending`;
      await this.loadUpcommingData(url, this.state.sizePerPage, 1);
  }

    // Method for Load itinerary as per page, pagesize and filter 
    async loadUpcommingData(url, sizePerPage, page) {
      const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      };
      try {
          const response = await fetch(url, requestOptions);
          if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const data = await response.json();
          console.log("Upcoming Data:", data.results); // Log the results
          this.setState({
              loadUpcomming: true,
              itineraries: data.results,
              totalSize: data.count,
              page: page,
              sizePerPage: sizePerPage,
          });
      } catch (error) {
          console.error("Error fetching upcoming data:", error);
          toastr.error("Failed to load upcoming payments", "Error");
      }
  }
    async loadPendingData(url, sizePerPage, page) {

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };
        await fetch(url, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    this.setState(() => ({ loadPending: true, pendingPayments: data.results, pendingtotalSize: data.count, pendingPage: page, sizePerPage }))
                },
                (error) => {
                    console.log(error, 'error-------------')
                }
            )

    }

    async loadCompletedData(url, sizePerPage, page) {

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        };
        await fetch(url, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    this.setState(() => ({ loadCompleted: true, completedPayments: data.results, completedtotalSize: data.count, completedPage: page, sizePerPage }))
                    console.log(data)
                },
                (error) => {
                    
                    console.log(error, 'error--------0000-----')
                }
            )

    }

    toggledescription(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    }

    // Change url for get itinerary listing as per seletced Filter 
    handleFilterSubmit(e, values) {
        const { selectedStartDate, selectedendDate, bookingDate, sizePerPage, selectedFilterOptions, selectedStatus, selectedUser, selectedPackegeType, activeTab } = this.state
        let filter_option = ""
        if (activeTab === 'upcomming') {
            if (selectedPackegeType.value === null) {
                toastr.error("Select Packege Type")
            } else {
                filter_option = `&packege=${selectedPackegeType.value}`
                let url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}${filter_option}`
                this.loadData(url, sizePerPage, 1)
            }

        } else if (activeTab === 'pending') {
            if (selectedStatus.value === null) {
                toastr.error("Select Status")
            } else {
                filter_option = `&status=${selectedStatus.value}`
                let url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}${filter_option}`
                this.loadData(url, sizePerPage, 1)
            }

        } else if (selectedFilterOptions.value === '3') {
            if (selectedUser.value === null) {
                toastr.error("Select Status")
            } else {
                filter_option = `&created_by__email=${selectedUser.value}`
                let url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}${filter_option}`
                this.loadData(url, sizePerPage, 1)
            }

        } else if (selectedFilterOptions.value === '4') {
            if (!selectedendDate) {
                toastr.error("Select From/To Date", "")
            } else {
                let startDate = Moment(selectedStartDate).format("YYYY-MM-DD");
                let endDate = Moment(selectedendDate).format("YYYY-MM-DD");

                filter_option = `&created__gte=${startDate}&created__lte=${endDate + "T23:59:59Z"}`
                let url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}${filter_option}`
                this.loadData(url, sizePerPage, 1)
            }
        } else if (selectedFilterOptions.value === '5') {

            filter_option = `&search=${values.name}`
            let url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}${filter_option}`
            this.loadData(url, sizePerPage, 1)


        }
        this.setState({ filter_option })

    }

    //  method for Clear all search and filter 
    clearFilter() {
        let selectedFilterOptions = { label: "Filter By ", value: null }
        this.setState({ selectedStartDate: null, selectedendDate: null, selectedFilterOptions, searchText: "" })
        let url = `${BaseUrl}/api/itineraries/itineraries/?size=${this.state.sizePerPage}`
        this.loadData(url, this.state.sizePerPage, 1, "")
    }

    // method for delete selected Itinerary and reload itinerary data as per current page and search input
    handleItineraryClicks = id => {
        const requestOptions = {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${this.obj.access}` },

        };
        fetch(`${BaseUrl}/api/itineraries/itineraries/${id}/`, requestOptions)
            .then(res => {
                if (res.status >= 400) {
                    console.log("error")
                }
                else {
                    let new_page = this.state.page
                    if (this.state.itineraries.length < 2) {
                        new_page = new_page > 1 ? new_page - 1 : 1
                    }
                    let url = `${BaseUrl}/api/itineraries/itineraries/?size=${this.state.sizePerPage}&page=${new_page}&is_template=False`
                    url = this.state.searchText && this.state.searchText !== "" ? url + `&search=${this.state.searchText}` : url
                    // this.loadData(url, this.state.sizePerPage, new_page)
                    this.setState({
                        itinerary_id: "",
                        success_confirm: true,
                        alert_confirm: false,
                        dynamic_title: "Deleted!",
                        dynamic_description: "Itinerary has been deleted.",
                        selectedStartDate: null,
                        selectedendDate: null,
                        bookingDate: null
                    })
                }
            }
            )
    }

    // Handle Table data as per filter and selected page  
    handleUpcommingTableChange = (type, { page, sizePerPage, searchText, }) => {

        setTimeout(() => {
            let new_page = page
            let url = `${BaseUrl}/api/itineraries/itinerary-payment/?size=${sizePerPage}&&page=${new_page}&gt_due_date=${this.state.today}&status=pending`


            if (this.state.filter_option !== "") {
                url = `${BaseUrl}/api/itineraries/itinerary-payment/?size=${sizePerPage}&page=${new_page}&gt_due_date=${this.state.today}&status=pending`
            }
            this.loadUpcommingData(url, sizePerPage, new_page)
        }, 1000);
    }

    handlePendingTableChange = (type, { page, sizePerPage, searchText }) => {
        setTimeout(() => {
            let new_page = page;
            let url = `${BaseUrl}/api/itineraries/itinerary-payment/?size=${sizePerPage}&page=${new_page}&due_date__lte=${this.state.today}&status=pending&ordering=-due_date`;
    
            if (this.state.filter_option !== "") {
                url = `${BaseUrl}/api/itineraries/itinerary-payment/?size=${sizePerPage}&page=${new_page}&due_date__lte=${this.state.today}&status=pending&ordering=-due_date`;
            }
            this.loadPendingData(url, sizePerPage, new_page);
        }, 1000);
    };

    handleCompletedTableChange = (type, { page, sizePerPage, searchText, }) => {

        setTimeout(() => {
            let new_page = page
            let url = `${BaseUrl}/api/itineraries/itinerary-payment/?size=${sizePerPage}&&page=${new_page}&status=completed`


            if (this.state.filter_option !== "") {
                url = `${BaseUrl}/api/itineraries/itinerary-payment/?size=${sizePerPage}&page=${new_page}&status=completed`
            }
            this.loadCompletedData(url, sizePerPage, new_page)
        }, 1000);
    }

    noDataIndication = () => {
        if (this.state.loadUpcomming && this.state.itineraries.length === 0) {
            return (

                <div className="d-flex align-items-center justify-content-center">
                    <h4 className="my-3">Table is Empty</h4>
                </div>
            )

        } else {
            return (

                <div className="d-flex align-items-center justify-content-center">
                    <Spinner className="my-3" color="dark" />
                </div>
            )

        }
    }

    pendingNoDataIndication = () => {
        if (this.state.loadPending && this.state.pendingPayments.length === 0) {
            return (

                <div className="d-flex align-items-center justify-content-center">
                    <h4 className="my-3">Table is Empty</h4>
                </div>
            )

        } else {
            return (

                <div className="d-flex align-items-center justify-content-center">
                    <Spinner className="my-3" color="dark" />
                </div>
            )

        }
    }

    completdNoDataIndication = () => {
        if (this.state.loadCompleted && this.state.completedPayments.length === 0) {
            return (

                <div className="d-flex align-items-center justify-content-center">
                    <h4 className="my-3">Table is Empty</h4>
                </div>
            )

        } else {
            return (

                <div className="d-flex align-items-center justify-content-center">
                    <Spinner className="my-3" color="dark" />
                </div>
            )

        }
    }

    render() {

        const { itineraries, sizePerPage, totalSize, page, selectedFilterOptions, today,
            pendingPayments, completedPayments, pendingPage, completedPage, pendingtotalSize, completedtotalSize } = this.state

        //pagination customization
        const upCommingPageOptions = {
            page: page,
            sizePerPage: sizePerPage,
            totalSize: totalSize,
            custom: true,
        }
        const PendingPageOptions = {
            page: pendingPage,
            sizePerPage: sizePerPage,
            totalSize: pendingtotalSize,
            custom: true,
        }
        const completedPageOptions = {
            page: completedPage,
            sizePerPage: sizePerPage,
            totalSize: completedtotalSize,
            custom: true,
        }

        const defaultSorted = [{
            dataField: 'id',
            order: 'asc'
        }];

        //Columns
        const itinerariesColumns = [
            {
                dataField: "id",
                text: "ID",
                sort: true,
                headerStyle: { width: '5%' },
                formatter: (cellContent, row) => (
                    `I-${row.id + 100}`
                )
            },
            {
                dataField: "itinerary",
                text: "Itinerary",
                sort: true,
                formatter: (cellContent, row) => (
                    <Link to={`/itinerary-detail/${cellContent.id}`} target="__blank" className="me-3 text-dark">{(cellContent.title).substring(0, 40)}</Link>
                ),
                title: (cell, row, rowIndex, colIndex) => `${cell.title}`
            },

            {
                dataField: "itinerary.customer_name",
                text: "Customer Name",
            },
            // {
            //     dataField: "packege",
            //     text: "Package Type",
            // },
            {
                dataField: "pending",
                text: "Pending Amount",
                formatter: (cellContent, row) => (
                    `₹ ${cellContent}`
                )
            },
            // {
            //     dataField: "status",
            //     text: "Status",
            //     sort: true,
            //     formatter: (cellContent, row) => (

            //         <Badge
            //         className={"font-size-12 badge-soft-warning"}
            //         color={"processing"}
            //         pill
            //         >
            //         {toTitleCase(row.status)}
            //         </Badge>
            //         )
            //   }, 
            {
                dataField: "itinerary.booking_date",
                text: "Booking Date",
                sort: true,
                formatter: (cellContent, row) => {
                    // Check for null, undefined, or empty string
                    if (!row.itinerary.booking_date) {
                        return "N/A";
                    }
                    const date = new Date(row.itinerary.booking_date);
                    // Check if the date is invalid
                    if (isNaN(date.getTime())) {
                        return "N/A";
                    }
                    // Format valid date as DD-MM-YYYY
                    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
                }
            },
                
            {
                dataField: "due_date",
                text: "Due Date",
                sort: true,
                formatter: (cellContent, row) => (
                    `${new Date(row.due_date).getDate()}-${new Date(row.due_date).getMonth() + 1}-${new Date(row.due_date).getFullYear()}`
                )
            },
            
            {
                dataField: "action",
                isDummyField: true,
                text: "Action",
                formatter: (cellContent, row) => (
                    // this.obj.user.is_superuser ?
                    //     <React.Fragment>
                    //         <Link to="#" onClick={() => this.setState({ copy_alert_confirm: true, itinerary_id: row.id })} className="me-3 text-secondary"><i className="mdi mdi-content-copy font-size-18"></i></Link>
                    //         <Link to="#" onClick={() => this.setState({ alert_confirm: true, itinerary_id: row.id })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                    //     </React.Fragment>
                    //     :
                    <React.Fragment>
                        <Link to={`itinerary-payment-detail/${row.itinerary.id}`} target="__blank" className="me-3 text-primary"><i className="fas fa-eye font-size-18"></i></Link>
                    </React.Fragment>
                ),
            },
        ]

        return (

            <React.Fragment>
                <div className="page-content">

                    <Container fluid>
                        <Breadcrumbs title="All Payments" breadcrumbItems={this.state.breadcrumbItems} />
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <div className="payments-desc ">
                                            <Nav tabs className="nav-tabs-custom " >
                                                <NavItem>
                                                    <NavLink
                                                        id="nav-link-upcomming"
                                                        className={classnames({
                                                            active:
                                                                this.state.activeTab ===
                                                                "upcomming",
                                                        })}
                                                        onClick={() => {
                                                            this.toggledescription("upcomming");
                                                        }}
                                                    >
                                                        Upcomming
                                                    </NavLink>
                                                </NavItem>


                                                <NavItem>
                                                    <NavLink
                                                        id="nav-link-pending"
                                                        className={classnames({
                                                            active:
                                                                this.state.activeTab ===
                                                                "pending",
                                                        })}
                                                        onClick={() => {
                                                            this.toggledescription("pending");
                                                        }}
                                                    >
                                                        Pending
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem >
                                                    <NavLink
                                                        id="nav-link-completed"
                                                        className={classnames({
                                                            active:
                                                                this.state.activeTab ===
                                                                "completed",
                                                        })}
                                                        onClick={() => {
                                                            this.toggledescription("completed");
                                                        }}
                                                    >
                                                        Completed
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                            <TabContent
                                                activeTab={this.state.activeTab}
                                                className="border border-top-0 p-4"
                                            >
                                                <TabPane tabId="upcomming">
                                                    <div className="table-responsive">
                                                        <PaginationProvider
                                                            pagination={paginationFactory(upCommingPageOptions)}
                                                            data={itineraries}
                                                        >
                                                            {({ paginationProps, paginationTableProps }) => (
                                                                <ToolkitProvider
                                                                    keyField="id"
                                                                    data={itineraries}
                                                                    columns={itinerariesColumns}
                                                                    remote={{ filter: true, pagination: true, sort: true, cellEdit: true }}
                                                                    bootstrap4
                                                                    search
                                                                >

                                                                    {toolkitProps => (
                                                                        <React.Fragment>
                                                                            {/* Filter and search box  */}
                                                                            {/* <Row className="mb-2">
                                                                                <Col sm="12">
                                                                                    <Row>
                                                                                        <Col sm="2">
                                                                                            <div className="mb-3 search-box" style={{ borderRadius: "30px" }}>
                                                                                                <Select
                                                                                                    value={this.state.selectedFilterOptions}
                                                                                                    onChange={(e) => this.setState({ selectedFilterOptions: e })}
                                                                                                    options={FilterOptions}
                                                                                                    classNamePrefix="select2-selection"
                                                                                                />
                                                                                            </div>
                                                                                        </Col>
                                                                                        <Col sm="10">
                                                                                            <AvForm className="needs-validation" onValidSubmit={this.handleFilterSubmit} >
                                                                                                <Row>
                                                                                                    <Col sm="12">
                                                                                                        {selectedFilterOptions.value ?
                                                                                                            <Row>
                                                                                                                {selectedFilterOptions.value === "4" ? (
                                                                                                                    <Col md="6">
                                                                                                                        <Row>
                                                                                                                            <Col md="6">
                                                                                                                                <div className="search-box mb-3">
                                                                                                                                    <DatePicker
                                                                                                                                        className="form-control"
                                                                                                                                        selected={this.state.selectedStartDate}
                                                                                                                                        onChange={(date) => this.setState({ selectedStartDate: date })}
                                                                                                                                        selectsStart
                                                                                                                                        startDate={new Date()}
                                                                                                                                        maxDate={new Date()}
                                                                                                                                        placeholderText="From Date"
                                                                                                                                        isClearable={true}
                                                                                                                                    />
                                                                                                                                </div>
                                                                                                                            </Col>
                                                                                                                            <Col md="6">
                                                                                                                                <div className="search-box mb-3">
                                                                                                                                    <DatePicker
                                                                                                                                        className="form-control"
                                                                                                                                        selected={this.state.selectedendDate}
                                                                                                                                        onChange={(date) => this.setState({ selectedendDate: date })}
                                                                                                                                        selectsEnd
                                                                                                                                        startDate={this.state.selectedStartDate}
                                                                                                                                        minDate={this.state.selectedStartDate}
                                                                                                                                        maxDate={new Date()}
                                                                                                                                        placeholderText="To Date"
                                                                                                                                        isClearable={true}
                                                                                                                                    />
                                                                                                                                </div>
                                                                                                                            </Col>

                                                                                                                        </Row>

                                                                                                                    </Col>

                                                                                                                )
                                                                                                                    :
                                                                                                                    null}

                                                                                                                <Col md="4">
                                                                                                                    <div className="mb-2">
                                                                                                                        <Button type="submit" color="primary" className="btn-rounded me-1">
                                                                                                                            <i className="mdi mdi-filter-outline me-1" />
                                                                                                                            Apply Filter
                                                                                                                        </Button>{" "}
                                                                                                                        {this.state.filter_option !== "" ?
                                                                                                                            <Button type="button" color="secondary" onClick={this.clearFilter} className="btn-rounded me-1">
                                                                                                                                <i className="mdi mdi-close me-1" />{" "}
                                                                                                                                Clear
                                                                                                                            </Button>
                                                                                                                            : null}
                                                                                                                    </div>
                                                                                                                </Col>

                                                                                                            </Row>
                                                                                                            : null}

                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </AvForm>
                                                                                        </Col>

                                                                                    </Row>

                                                                                </Col>

                                                                                
                                                                            </Row> */}
                                                                            {/* End Filter and search box  */}
                                                                            <div className="table-responsive">

                                                                                <BootstrapTable
                                                                                    remote
                                                                                    {...toolkitProps.baseProps}
                                                                                    {...paginationTableProps}
                                                                                    responsive
                                                                                    bordered={false}
                                                                                    striped={true}
                                                                                    defaultSorted={defaultSorted}
                                                                                    headerWrapperClasses={"table-light"}
                                                                                    columns={itinerariesColumns}
                                                                                    onTableChange={this.handleUpcommingTableChange}
                                                                                    noDataIndication={() => this.noDataIndication()}
                                                                                    hover
                                                                                    classes={
                                                                                        "table align-middle table-nowrap"
                                                                                    }
                                                                                />

                                                                            </div>
                                                                            <div className="pagination pagination-rounded justify-content-end mb-2">
                                                                                <PaginationListStandalone
                                                                                    {...paginationProps}
                                                                                />
                                                                            </div>

                                                                        </React.Fragment>
                                                                    )}
                                                                </ToolkitProvider>
                                                            )}
                                                        </PaginationProvider>

                                                    </div>
                                                </TabPane>
                                                <TabPane tabId="pending">

                                                    <PaginationProvider
                                                        pagination={paginationFactory(PendingPageOptions)}
                                                        data={pendingPayments}
                                                    >
                                                        {({ paginationProps, paginationTableProps }) => (
                                                            <ToolkitProvider
                                                                keyField="id"
                                                                data={pendingPayments}
                                                                columns={itinerariesColumns}
                                                                remote={{ filter: true, pagination: true, sort: true, cellEdit: true }}
                                                                bootstrap4
                                                                search
                                                            >

                                                                {toolkitProps => (
                                                                    <React.Fragment>
                                                                        {/* Filter and search box  */}
                                                                        {/* <Row className="mb-2">
                                                                            <Col sm="12">
                                                                                <Row>
                                                                                    <Col sm="2">
                                                                                        <div className="mb-3 search-box" style={{ borderRadius: "30px" }}>
                                                                                            <Select
                                                                                                value={this.state.selectedFilterOptions}
                                                                                                onChange={(e) => this.setState({ selectedFilterOptions: e })}
                                                                                                options={FilterOptions}
                                                                                                classNamePrefix="select2-selection"
                                                                                            />
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col sm="10">
                                                                                        <AvForm className="needs-validation" onValidSubmit={this.handleFilterSubmit} >
                                                                                            <Row>
                                                                                                <Col sm="12">
                                                                                                    {selectedFilterOptions.value ?
                                                                                                        <Row>
                                                                                                            {selectedFilterOptions.value === "4" ? (
                                                                                                                <Col md="6">
                                                                                                                    <Row>
                                                                                                                        <Col md="6">
                                                                                                                            <div className="search-box mb-3">
                                                                                                                                <DatePicker
                                                                                                                                    className="form-control"
                                                                                                                                    selected={this.state.selectedStartDate}
                                                                                                                                    onChange={(date) => this.setState({ selectedStartDate: date })}
                                                                                                                                    selectsStart
                                                                                                                                    startDate={new Date()}
                                                                                                                                    maxDate={new Date()}
                                                                                                                                    placeholderText="From Date"
                                                                                                                                    isClearable={true}
                                                                                                                                />
                                                                                                                            </div>
                                                                                                                        </Col>
                                                                                                                        <Col md="6">
                                                                                                                            <div className="search-box mb-3">
                                                                                                                                <DatePicker
                                                                                                                                    className="form-control"
                                                                                                                                    selected={this.state.selectedendDate}
                                                                                                                                    onChange={(date) => this.setState({ selectedendDate: date })}
                                                                                                                                    selectsEnd
                                                                                                                                    startDate={this.state.selectedStartDate}
                                                                                                                                    minDate={this.state.selectedStartDate}
                                                                                                                                    maxDate={new Date()}
                                                                                                                                    placeholderText="To Date"
                                                                                                                                    isClearable={true}
                                                                                                                                />
                                                                                                                            </div>
                                                                                                                        </Col>

                                                                                                                    </Row>

                                                                                                                </Col>

                                                                                                            )
                                                                                                                :
                                                                                                                null}

                                                                                                            <Col md="4">
                                                                                                                <div className="mb-2">
                                                                                                                    <Button type="submit" color="primary" className="btn-rounded me-1">
                                                                                                                        <i className="mdi mdi-filter-outline me-1" />
                                                                                                                        Apply Filter
                                                                                                                    </Button>{" "}
                                                                                                                    {this.state.filter_option !== "" ?
                                                                                                                        <Button type="button" color="secondary" onClick={this.clearFilter} className="btn-rounded me-1">
                                                                                                                            <i className="mdi mdi-close me-1" />{" "}
                                                                                                                            Clear
                                                                                                                        </Button>
                                                                                                                        : null}
                                                                                                                </div>
                                                                                                            </Col>

                                                                                                        </Row>
                                                                                                        : null}

                                                                                                </Col>
                                                                                            </Row>
                                                                                        </AvForm>
                                                                                    </Col>

                                                                                </Row>

                                                                            </Col>

                                                                            
                                                                        </Row> */}
                                                                        {/* End Filter and search box  */}
                                                                        <div className="table-responsive">

                                                                            <BootstrapTable
                                                                                remote
                                                                                {...toolkitProps.baseProps}
                                                                                {...paginationTableProps}
                                                                                responsive
                                                                                bordered={false}
                                                                                striped={true}
                                                                                defaultSorted={defaultSorted}
                                                                                headerWrapperClasses={"table-light"}
                                                                                columns={itinerariesColumns}
                                                                                onTableChange={this.handlePendingTableChange}
                                                                                noDataIndication={() => this.pendingNoDataIndication()}
                                                                                hover
                                                                                classes={
                                                                                    "table align-middle table-nowrap"
                                                                                }
                                                                            />

                                                                        </div>
                                                                        <div className="pagination pagination-rounded justify-content-end mb-2">
                                                                            <PaginationListStandalone
                                                                                {...paginationProps}
                                                                            />
                                                                        </div>

                                                                    </React.Fragment>
                                                                )}
                                                            </ToolkitProvider>
                                                        )}
                                                    </PaginationProvider>


                                                </TabPane>
                                                <TabPane tabId="completed">
                                                    <PaginationProvider
                                                        pagination={paginationFactory(completedPageOptions)}
                                                        data={completedPayments}
                                                    >
                                                        {({ paginationProps, paginationTableProps }) => (
                                                            <ToolkitProvider
                                                                keyField="id"
                                                                data={completedPayments}
                                                                columns={itinerariesColumns}
                                                                remote={{ filter: true, pagination: true, sort: true, cellEdit: true }}
                                                                bootstrap4
                                                                search
                                                            >

                                                                {toolkitProps => (
                                                                    <React.Fragment>
                                                                        {/* Filter and search box  */}
                                                                        {/* <Row className="mb-2">
                                                                            <Col sm="12">
                                                                                <Row>
                                                                                    <Col sm="2">
                                                                                        <div className="mb-3 search-box" style={{ borderRadius: "30px" }}>
                                                                                            <Select
                                                                                                value={this.state.selectedFilterOptions}
                                                                                                onChange={(e) => this.setState({ selectedFilterOptions: e })}
                                                                                                options={FilterOptions}
                                                                                                classNamePrefix="select2-selection"
                                                                                            />
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col sm="10">
                                                                                        <AvForm className="needs-validation" onValidSubmit={this.handleFilterSubmit} >
                                                                                            <Row>
                                                                                                <Col sm="12">
                                                                                                    {selectedFilterOptions.value ?
                                                                                                        <Row>
                                                                                                            {selectedFilterOptions.value === "4" ? (
                                                                                                                <Col md="6">
                                                                                                                    <Row>
                                                                                                                        <Col md="6">
                                                                                                                            <div className="search-box mb-3">
                                                                                                                                <DatePicker
                                                                                                                                    className="form-control"
                                                                                                                                    selected={this.state.selectedStartDate}
                                                                                                                                    onChange={(date) => this.setState({ selectedStartDate: date })}
                                                                                                                                    selectsStart
                                                                                                                                    startDate={new Date()}
                                                                                                                                    maxDate={new Date()}
                                                                                                                                    placeholderText="From Date"
                                                                                                                                    isClearable={true}
                                                                                                                                />
                                                                                                                            </div>
                                                                                                                        </Col>
                                                                                                                        <Col md="6">
                                                                                                                            <div className="search-box mb-3">
                                                                                                                                <DatePicker
                                                                                                                                    className="form-control"
                                                                                                                                    selected={this.state.selectedendDate}
                                                                                                                                    onChange={(date) => this.setState({ selectedendDate: date })}
                                                                                                                                    selectsEnd
                                                                                                                                    startDate={this.state.selectedStartDate}
                                                                                                                                    minDate={this.state.selectedStartDate}
                                                                                                                                    maxDate={new Date()}
                                                                                                                                    placeholderText="To Date"
                                                                                                                                    isClearable={true}
                                                                                                                                />
                                                                                                                            </div>
                                                                                                                        </Col>

                                                                                                                    </Row>

                                                                                                                </Col>

                                                                                                            )
                                                                                                                :
                                                                                                                null}

                                                                                                            <Col md="4">
                                                                                                                <div className="mb-2">
                                                                                                                    <Button type="submit" color="primary" className="btn-rounded me-1">
                                                                                                                        <i className="mdi mdi-filter-outline me-1" />
                                                                                                                        Apply Filter
                                                                                                                    </Button>{" "}
                                                                                                                    {this.state.filter_option !== "" ?
                                                                                                                        <Button type="button" color="secondary" onClick={this.clearFilter} className="btn-rounded me-1">
                                                                                                                            <i className="mdi mdi-close me-1" />{" "}
                                                                                                                            Clear
                                                                                                                        </Button>
                                                                                                                        : null}
                                                                                                                </div>
                                                                                                            </Col>

                                                                                                        </Row>
                                                                                                        : null}

                                                                                                </Col>
                                                                                            </Row>
                                                                                        </AvForm>
                                                                                    </Col>

                                                                                </Row>

                                                                            </Col>

                                                                            
                                                                        </Row> */}
                                                                        {/* End Filter and search box  */}
                                                                        <div className="table-responsive">

                                                                            <BootstrapTable
                                                                                remote
                                                                                {...toolkitProps.baseProps}
                                                                                {...paginationTableProps}
                                                                                responsive
                                                                                bordered={false}
                                                                                striped={true}
                                                                                defaultSorted={defaultSorted}
                                                                                headerWrapperClasses={"table-light"}
                                                                                columns={itinerariesColumns}
                                                                                onTableChange={this.handleCompletedTableChange}
                                                                                noDataIndication={() => this.completdNoDataIndication()}
                                                                                hover
                                                                                classes={
                                                                                    "table align-middle table-nowrap"
                                                                                }
                                                                            />

                                                                        </div>
                                                                        <div className="pagination pagination-rounded justify-content-end mb-2">
                                                                            <PaginationListStandalone
                                                                                {...paginationProps}
                                                                            />
                                                                        </div>

                                                                    </React.Fragment>
                                                                )}
                                                            </ToolkitProvider>
                                                        )}
                                                    </PaginationProvider>
                                                </TabPane>
                                            </TabContent>
                                        </div>

                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

export default ItinerariesPayments